import React from 'react';
import { Popup } from 'devextreme-react/popup';
import { Button } from './Button';
import { ComponentProps } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faX } from '@fortawesome/free-solid-svg-icons';
import '../../scss/controls/_genericPopup.scss';

type ButtonProps = ComponentProps<typeof Button>;

export const GenericPopup: React.FC<{
    id: string;
    isOpen: boolean;
    children: any;
    actionButtons?: ButtonProps[];
    title?: string;
    showCloseButton?: boolean;
    showTitle?: boolean;
    width?: string;
    height?: string;
    minHeight?: string;
    maxWidth?: string;
    maxHeight?: string;
    handleClose?: () => void;
    buttonAlignment?: string;
    hideOnOutsideClick?: boolean;
    wrapTitle?: boolean;
}> = ({
    id,
    isOpen,
    children,
    actionButtons,
    title,
    showCloseButton = false,
    showTitle = false,
    width = 'auto',
    height = 'auto',
    minHeight = 'auto',
    maxWidth = 'auto',
    maxHeight,
    handleClose,
    buttonAlignment = 'center',
    hideOnOutsideClick = false,
    wrapTitle = false,
}) => {
    const wrapCustomRender = () => (
        <div style={{ display: 'flex', width: '100%' }}>
            <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', width: '100%' }}>{title}</div>
            {showCloseButton && (
                <div
                    style={{ width: '28px', height: '32px', float: 'right', cursor: 'pointer' }}
                    onClick={handleClose}
                >
                    <div style={{ borderRadius: '24px', backgroundColor: '#EAEEFF', textAlign: 'center' }}>
                        <FontAwesomeIcon
                            key='customPopupCloseButton'
                            icon={faX}
                            color='#464646'
                            width='10px'
                        />
                    </div>
                </div>
            )}
        </div>
    );

    return (
        <>
            <Popup
                id={id}
                visible={isOpen}
                title={title}
                showCloseButton={showCloseButton}
                showTitle={showTitle}
                width={width}
                height={height}
                minHeight={minHeight}
                maxWidth={maxWidth}
                maxHeight={maxHeight}
                dragEnabled={false}
                onHiding={handleClose}
                hideOnOutsideClick={hideOnOutsideClick}
                titleRender={wrapTitle ? wrapCustomRender : undefined}
            >
                {maxHeight ? (
                    <div className='genericPopupContentWrapper'>
                        <div className='genericPopup genericPopupContent'>{children}</div>
                    </div>
                ) : (
                    <div className='genericPopup genericPopupContent'>{children}</div>
                )}
                <div className={`genericPopup genericPopupActions ${buttonAlignment}`}>
                    {actionButtons?.map((b) => (
                        <Button
                            id={b.id}
                            key={b.id}
                            theme={b.theme}
                            disabled={b.disabled}
                            handleClick={b.handleClick}
                            hint={b.hint}
                            width={b.width}
                        >
                            {b.children}
                        </Button>
                    ))}
                </div>
            </Popup>
        </>
    );
};
